(function () {
  var MOBILE_MENU_STYLE_ID = 'yt-mobile-menu-drawer-styles';

  function injectMobileMenuStyles() {
    if (document.getElementById(MOBILE_MENU_STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = MOBILE_MENU_STYLE_ID;
    style.textContent = [
      '@media only screen and (max-width: 1024px) {',
      '#header .top-bar { position: relative; z-index: 10001; }',
      '#header .top-bar details[data-mobile-menu] { position: static; }',
      '#header .mobile-menu-container { display: none !important; opacity: 1 !important; visibility: visible !important; pointer-events: auto !important; }',
      'body.mobile-menu-open #header .mobile-menu-container { display: block !important; position: fixed !important; top: var(--yt-mobile-menu-top, 52px) !important; left: 0 !important; right: 0 !important; bottom: 0 !important; width: 100% !important; max-width: 100vw !important; margin: 0 !important; padding: 0 !important; overflow-x: hidden !important; overflow-y: auto !important; -webkit-overflow-scrolling: touch; z-index: 10000 !important; background: var(--yt-header-bg, var(--yt-shop-bg, #faf8f5)) !important; box-shadow: none !important; transform: none !important; }',
      'body.mobile-menu-open #header .mobile-menu-container .menu, body.mobile-menu-open #header #mobile_menu { display: block !important; visibility: visible !important; opacity: 1 !important; }',
      'body.mobile-menu-open.is-active #header { overflow: visible !important; bottom: auto !important; height: auto !important; max-height: none !important; }',
      '}',
    ].join('');
    document.head.appendChild(style);
  }

  function syncMobileMenuTop() {
    var header = document.getElementById('header');
    if (!header) return;
    document.documentElement.style.setProperty(
      '--yt-mobile-menu-top',
      `${Math.round(header.getBoundingClientRect().bottom)}px`,
    );
  }

  function setMobileMenuOpen(details, menu, icon, open) {
    syncMobileMenuTop();
    details.open = open;
    document.body.classList.toggle('mobile-menu-open', open);
    document.body.classList.toggle('is-active', open);
    if (icon) icon.classList.toggle('open', open);
    if (menu) menu.setAttribute('data-animation-state', open ? 'open' : 'closed');
    if (open) promoteMegaMenuParents();
  }

  function megaMenuHandlesFromSource(source) {
    return ((source.getAttribute('data-meganav-handle') || '') + ' ' + (source.getAttribute('data-meganav-extra-handles') || ''))
      .split(/[\s,]+/)
      .filter(Boolean);
  }

  function ensureMegaParentChrome(li) {
    if (!li) return;
    li.classList.add('sublink');
    var link = li.querySelector(':scope > a');
    if (!link) return;
    if (!link.querySelector('.icon-down-arrow')) {
      var arrow = document.createElement('span');
      arrow.className = 'right icon-down-arrow';
      link.appendChild(arrow);
    }
    var submenu = link.nextElementSibling;
    if (!submenu || submenu.tagName !== 'UL') {
      submenu = document.createElement('ul');
      submenu.className = 'mobile-mega-menu';
      submenu.setAttribute('data-meganav-target-container', '');
      link.parentNode.appendChild(submenu);
    }
  }

  function promoteMegaMenuParents() {
    var mobileMenu = document.getElementById('mobile_menu');
    if (!mobileMenu) return;

    document.querySelectorAll('[data-meganav-mobile]').forEach(function (source) {
      megaMenuHandlesFromSource(source).forEach(function (handle) {
        mobileMenu.querySelectorAll(':scope > li[data-meganav-mobile-target="' + handle + '"]').forEach(ensureMegaParentChrome);
      });
    });
  }

  function isInsideInjectedMegaPanel(link) {
    if (!link.closest('[data-meganav-target-container]')) return false;

    var block = link.closest('.mobile-mega-menu_block.sublink');
    if (!block) return false;

    // Menu column title <a> (direct child of block) should still accordion.
    if (link.parentElement === block) return false;

    return true;
  }

  function toggleSubmenu(link) {
    var submenu = link.nextElementSibling;
    if (!submenu || submenu.tagName !== 'UL') return false;

    if (isInsideInjectedMegaPanel(link)) return false;

    link.classList.toggle('active');
    var arrow = link.querySelector('.icon-down-arrow');
    if (arrow) arrow.classList.toggle('active');

    // Load this group's deferred images only when it opens.
    if (window.YTMegaMenuImages && typeof window.YTMegaMenuImages.load === 'function') {
      window.YTMegaMenuImages.load(submenu);
    }

    if (window.jQuery) {
      window.jQuery(submenu).slideToggle(200);
    } else {
      submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
    }

    return true;
  }

  function initMobileSubmenuAccordion() {
    var mobileMenu = document.getElementById('mobile_menu');
    if (!mobileMenu || mobileMenu.dataset.ytSubmenuInit === 'true') return;

    mobileMenu.dataset.ytSubmenuInit = 'true';

    mobileMenu.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link || !mobileMenu.contains(link)) return;

      var parentLi = link.parentElement;
      var isTopLevel = parentLi && parentLi.parentElement === mobileMenu;
      var injectedMega = false;

      if (
        isTopLevel &&
        parentLi.hasAttribute('data-meganav-mobile-target') &&
        window.meganavManager &&
        typeof window.meganavManager.injectOne === 'function'
      ) {
        var handle = parentLi.getAttribute('data-meganav-mobile-target');
        injectedMega = window.meganavManager.injectOne(handle);
        var injected = mobileMenu.querySelector(':scope > li[data-meganav-mobile-target="' + handle + '"] > a');
        if (injected) link = injected;
      }

      if (!toggleSubmenu(link)) {
        if (!injectedMega) return;
      }

      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  function initMobileMenuDrawerFix() {
    if (!window.matchMedia('(max-width: 1024px)').matches) return;

    var details = document.querySelector('#header [data-mobile-menu]');
    if (!details || details.dataset.ytMenuFixInit === 'true') return;

    var trigger = details.querySelector('[data-mobile-menu-trigger]');
    var menu = details.querySelector('.mobile-menu-container');
    var icon = details.querySelector('[data-mobile-menu-icon]');
    if (!trigger || !menu) return;

    details.dataset.ytMenuFixInit = 'true';
    injectMobileMenuStyles();

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var open = !document.body.classList.contains('mobile-menu-open');
      setMobileMenuOpen(details, menu, icon, open);
    }, true);

    document.body.addEventListener('click', function (e) {
      if (!document.body.classList.contains('mobile-menu-open')) return;
      if (details.contains(e.target)) return;
      setMobileMenuOpen(details, menu, icon, false);
    });

    if (icon) {
      var observer = new MutationObserver(function () {
        var shouldOpen = icon.classList.contains('open');
        if (shouldOpen === document.body.classList.contains('mobile-menu-open')) return;
        setMobileMenuOpen(details, menu, icon, shouldOpen);
      });
      observer.observe(icon, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function init() {
    initMobileSubmenuAccordion();
    initMobileMenuDrawerFix();
    if (document.body.classList.contains('mobile-menu-open')) promoteMegaMenuParents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  if (window.matchMedia) {
    var hamburgerMq = window.matchMedia('(max-width: 1024px)');
    if (hamburgerMq.addEventListener) {
      hamburgerMq.addEventListener('change', function (e) {
        if (e.matches) init();
      });
    }
  }
})();
